import { createClient } from '@supabase/supabase-js'

/**
 * Supabase client（フロントエンド用、anon key）
 *
 * 環境変数: VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY
 * Vite では `VITE_` プレフィックスの env のみフロントへ露出する。
 */
const url = import.meta.env.VITE_SUPABASE_URL
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!url || !anonKey) {
  throw new Error(
    'VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY が設定されていません（apps/app/.env）',
  )
}

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true, // OAuth callback のため
  },
})
